import React from 'react';
import { IconButton, Menu, MenuItem, Box } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    handleClose();
  };

  return (
    <Box>
      <IconButton
        onClick={handleClick}
        sx={{
          color: 'inherit',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
          },
        }}
      >
        <LanguageIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{
          '& .MuiPaper-root': {
            backgroundColor: 'rgba(5, 8, 16, 0.9)',
            color: 'white',
          },
        }}
      >
        <MenuItem 
          onClick={() => changeLanguage('es')}
          selected={i18n.language === 'es'}
          sx={{
            '&:hover': {
              backgroundColor: 'rgba(34, 225, 101, 0.1)',
            },
            '&.Mui-selected': {
              backgroundColor: 'rgba(34, 225, 101, 0.2)',
            },
          }}
        >
          Español
        </MenuItem>
        <MenuItem 
          onClick={() => changeLanguage('en')}
          selected={i18n.language === 'en'}
          sx={{
            '&:hover': {
              backgroundColor: 'rgba(34, 225, 101, 0.1)',
            },
            '&.Mui-selected': {
              backgroundColor: 'rgba(34, 225, 101, 0.2)',
            },
          }}
        >
          English
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default LanguageSwitcher; 